import { BasePage } from "./base-page";

export abstract class BasePagedPage<TSearch, TItem> extends BasePage {
    public search?: TSearch;

    public items: Array<TItem> = [];

    public page = 1;

    public pages = 0;

    protected pageSize = 100;

    public getPages() {
        if (!this.pages) {
            return [];
        }
        const first = 1;

        const result: Array<{ label: string, page?: number, isDisabled: boolean }> = [];

        result.push({
            label: first.toString(),
            isDisabled: false,
            page: first
        });

        let start = this.page - 5;
        let last = this.page + 5;

        if (start > first) {
            if (first !== start) {
                result.push({
                    label: '...',
                    isDisabled: true
                });
            }
        } else {
            last -= start;
            start = 2;
        }

        if (last > this.pages) {
            start -= last - this.pages;
            if (start < 2) {
                start = 2;
            }
        }

        for (let i = start; i <= last && i < this.pages; i++) {
            result.push({
                label: i.toString(),
                isDisabled: false,
                page: i
            });
        }

        if (last < this.pages) {
            result.push({
                label: '...',
                isDisabled: true
            });
        }

        if (result.length > 1) {

            result.push({
                label: this.pages.toString(),
                isDisabled: false,
                page: this.pages
            });
        }

        return result;
    }

    public searchItems() {
        this.getData(1);
    }

    public abstract getData(page?: number): void;
}
